<template>
  <div
    :class="classes"
    :style="styling"
    class="overlay-menu">
    <div class="overlay-menu__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "OverlayMenu",
  props: {
    alias: {
      type: String,
      default: "navigation"
    }
  },
  computed: {
    classes () {
      let result = "closed";

      if ( this.activeOverlay && this.activeOverlay.open ) {
        result = "open";
      }

      return result;
    },
    styling () {
      let result;

      if ( this.activeOverlay && this.activeOverlay.open ) {
        result = {
          right: 0
        };
      } else {
        result = {
          right: "-80%"
        };
      }

      return result;
    },
    activeOverlay () {
      return this.overlays.find( x => x.alias === this.alias );
    },
    ...mapState( {
      overlays: state => state.overlay.overlays
    } )
  }
};
</script>

<style lang="less" scoped>
  .overlay-menu {
    position: fixed;
    top: -50px;
    bottom: -50px;
    right: 0;
    width: 80%;
    max-width: 300px;
    z-index: 9999;
    margin: 50px 0;
  }
</style>
